<template>
  <div class="main">
    <MyHeader class="header"></MyHeader>
    <MobilenewHeader class="m-header"></MobilenewHeader>
    <!-- 移动端布局 -->
    <div class="m-loopbox">
      <div>
      <p>打造农业新生态</p>
      <p>以“区块链溯源品质保险” </p>
      <p>为内核的农产品区域公用品牌打造新模式</p>
      </div>
    </div>
    <div class="m-product">
      <div class="w1200">
        <div class="title">
          <img src="@/assets/imgs/cp.png" alt="" class="w100" />
        </div>
        <div class="content">
          以“区块链溯源品质保险”为内核的政府+产学研农产品区域公用品牌建设新模式是由四川沁链云科科技有限公司和中国网安联合研发，并联合人保财险、华测检测（CTI）、农业高科技机构、西华大学以及中国热科院、川农大，省农科院相关专家共同打造的一种新模式。旨在为地方政府提供区块链溯源体系平台服务、优质农产品品质保险服务、优质农产品品质检测、农业金融以及相关数据包构建服务，利用相关云计算，物联网，和大数据服务共同帮助地方政府打造优秀农产品区域公用品牌。为品牌增信、赋能、溢价
        </div>
        <div class="lct">
          <img src="@/assets/imgs/jgt.png" alt="" class="w100" />
        </div>
      </div>
    </div>
    <div class="m-youshi">
      <div class="w750">
        <div class="title">
          <img src="@/assets/imgs/ys.png" alt="" class="w100" />
        </div>
        <div class="content">
          以区块链、物联网、大数据为支撑，制定标准，打破信息孤岛，建立溯源生态及意识
        </div>
        <div class="list">
          <div class="list-item" v-for="(item, key) in list2" :key="key">
            <!-- require('../../assets/imgs/m-a.png') -->
            <div class="tips" :style="
              `background-image: url('${
                 item.src
              }')`
            ">
              <img :src="item.icon" alt="" class="icon" />
              <div class="world">
                {{ item.title }}
              </div>
            </div>
            <div class="mc">
              <div class="discription">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-news">
      <div class="w750">
        <div class="title">
          <img src="@/assets/imgs/../../assets/imgs/news1.svg" alt="" class="w100" />
        </div>
        <!-- <div class="content">
          汇聚国内外行业新闻。获得第一手行业新闻资讯
        </div> -->
        <div class="list">
          <!-- src: require('@/assets/imgs/x1.png'),
          icon: require('@/assets/imgs/a1.png'),
          newsTitle: '数据可信',
          newsDesc: ' 利用区块链作为不可篡改、去中心化的“信任技术”，与大数据、物联网结合，解决信息孤岛，溯源信息的信任问题。',
          publishTime:"2020-01-01" -->
          <!-- <div class="list-item" v-for="(item, key) in newsList3" :key="key" @click="toMnews(item)">
            <div class="tips" :style="
              `background-image: url('${
                 require('@/assets/imgs/m-a.png')
              }')`
            ">
              
              <img :src="item.src" alt="" class="icon" />
              <div class="world">
                {{ item.newsTitle }}
              </div>
            </div>
            <div class="mc">
              <p>{{item.title}}</p>
              <div class="discription">
                {{ item.newsDesc }}
              </div>
            </div>
          </div> -->
          <div class="list-item" v-for="(item, key) in newsList" :key="key" @click="toMnews(item)">
            <!-- require('../../assets/imgs/m-a.png') -->
            <!-- <div v-html="item.content" ></div> -->
            <div class="tips" :style="
              `background-image: url('${
                 getImgSrc(item.content)[0]
              }')`
            ">
              <!-- <img :src="item.icon" alt="" class="icon" /> -->
              <!-- <div class="world">
                {{ item.title }}
              </div> -->
            </div>
            <div class="mc">
              <p>{{item.title}}</p>
              <div class="discription">
                {{ item.introduce }}
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- <div class="m-load">
          <p>查看更多>></p>
        </div> -->
    </div>
    <div class="m-bottom">
      <div >
        <p>Copyright © 2019 QINLIAN, All Rights Reserved. </p>
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/"
        >蜀ICP备19033163号-2 
        </a>
      </div>
    </div>
   
    <!-- web端页面 -->
    <div class="loopbox">
      <el-carousel class="loop-content">
        <el-carousel-item v-for="(item, key) in list" :key="key" class="loop-item">
          <img :src="item.src" alt="" class="w100" />
          <p class="lb-title1" :style="{ top: ratioConfig.ratio360 + 'px' }">{{ item.t1 }}</p>
          <p class="lb-title2" :style="{ top: ratioConfig.ratio400 + 'px' }">{{ item.t2 }}</p>
        </el-carousel-item>
      </el-carousel>
      
      <!-- <div class="search-box">
        <div class="w1200">
          <Tab-Search></Tab-Search>
        </div>
      </div> -->
    </div>
    <div class="product">
      <div class="w1200">
        <div class="title">
          <img src="@/assets/imgs/cp.png" alt="" class="w100" />
        </div>
        <div class="content">
          以“区块链溯源品质保险”为内核的政府+产学研农产品区域公用品牌建设新模式是由四川沁链云科科技有限公司和中国网安联合研发，并联合人保财险、华测检测（CTI）、农业高科技机构、西华大学以及中国热科院、川农大，省农科院相关专家共同打造的一种新模式。旨在为地方政府提供区块链溯源体系平台服务、优质农产品品质保险服务、优质农产品品质检测、农业金融以及相关数据包构建服务，利用相关云计算，物联网，和大数据服务共同帮助地方政府打造优秀农产品区域公用品牌。为品牌增信、赋能、溢价
        </div>
        <div class="lct">
          <img src="@/assets/imgs/jgt.png" alt="" class="w100" />
        </div>
      </div>
    </div>
    <div class="youshi">
      <div class="w1200">
        <div class="title">
          <img src="@/assets/imgs/ys.png" alt="" class="w100" />
        </div>
        <div class="content">
          以区块链、物联网、大数据、科研高校为支撑，搭建平台，制定标准，打破信息孤岛，建立溯源生态及意识
        </div>
        <div class="list">
          <div class="list-item" v-for="(item, key) in list1" :key="key">
            <img :src="item.src" alt="" class="w100" />
            <div class="tips">
              <img :src="item.icon" alt="" class="icon" />
              <div class="yi"></div>
              <div class="world">
                {{ item.title }}
              </div>
            </div>
            <div class="mc">
              <div class="discription">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="news">
      <div class="w1200">
        <div class="title"></div>
        <div class="news-center">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="新闻动态" name="1"> </el-tab-pane>
            <el-tab-pane label="信链资讯" name="2"></el-tab-pane>
            <el-tab-pane label="媒体视角" name="3"></el-tab-pane>
            <div class="newsActive">
              <div class="active-content">
                <ul v-if="newsList.length">
                  <li v-for="(item, index) in newsList" :key="index" @click="clickNew(item.id, activeName)">
                    <p class="new-name">{{ item.newsTitle }}</p>
                    <div class="new-text" :style="'min-height:50px'">
                      <p :style="'min-height:50px'">{{ item.newsDesc }}</p>
                      <span>{{ renderTime(item.publishTime) }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="active-right">
                <router-link to="/news">更多新闻></router-link>
                <ul class="imgsList">
                  <li>
                    <div class="right-img">
                      <img src="@/assets/imgs/news-1.png" />
                      <div>
                        <p></p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="right-img">
                      <img src="@/assets/imgs/news-2.png" />
                      <div>
                        <p>舌尖上的安全</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-tabs>
        </div>
      </div>
    </div> -->

    <div class="news">
      <div class="w1200">
        <div class="title"></div>
        <div class="news-center">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="新闻动态" name="1"> </el-tab-pane>
            <!-- <el-tab-pane label="信链资讯" name="2"></el-tab-pane>
            <el-tab-pane label="媒体视角" name="3"></el-tab-pane> -->
            <div class="newsActive">
              <div class="active-content">
                <ul v-if="newsList.length">
                  <li v-for="(item, index) in newsList" :key="index" @click="clickNew(item.id, activeName)">
                    <p class="new-name">{{ item.title }}</p>
                    <div class="new-text" :style="'min-height:50px'">
                      <p :style="'min-height:50px'">{{ item.introduce }}</p>
                      <span>{{ renderTime(item.createTime) }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- <div class="active-right">
                <router-link to="/news">更多新闻></router-link>
                <ul class="imgsList">
                  <li>
                    <div class="right-img">
                      <img src="@/assets/imgs/news-1.png" />
                      <div>
                        <p></p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="right-img">
                      <img src="@/assets/imgs/news-2.png" />
                      <div>
                        <p>舌尖上的安全</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div> -->
            </div>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- <div > -->
        <span>Copyright © 2019 QINLIAN, All Rights Reserved. </span>
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/"
          style="display:inline-block;text-decoration:underline;height:20px;line-height:30px;color:white;"
        >蜀ICP备19033163号-2 

          <img
            src="@/assets/imgs/8.png"
            style="margin-left:5px;display:inline-block;height:16px;vertical-align: middle;margin-top:-5px;"
          /></a>
      <!-- </div> -->
    </div>
    
  </div>
</template>

<script>
import MyHeader from '@/components/newHeader.vue'
import MobilenewHeader from '@/components/MobilenewHeader.vue'

// import HeadLine from "@/components/HeadLine.vue";
// import TabSearch from "@/components/tabSearchs.vue";
export default {
  name: "mainPage",
  data() {
    return {
      list: [
        {
          src: require('@/assets/imgs/a.png'),
          t1: '打造农业新生态',
          t2: '区块链溯源品质保险”为内核的政府+产学研农产品区域公用品牌建设新模式'
        },
        // {
        //   src: require('@/assets/imgs/b.jpg'),
        //   t1: '更完善的农产品服务生态',
        //   t2: '联合优质农企、保险公司、检测机构与相关协会，打造优质农产品服务生态'
        // },
        // {
        //   src: require('@/assets/imgs/c.jpg'),
        //   t1: '农产品品质保险',
        //   t2: '制定品质标准，溯源即投保，消费可获赔'
        // },

      ],
      list1: [
        {
          src: require('@/assets/imgs/x1.png'),
          icon: require('@/assets/imgs/a1.png'),
          title: '数据可信',
          content: ' 利用区块链作为不可篡改、去中心化的“信任技术”，与大数据、物联网结合，解决信息孤岛，溯源信息的信任问题。'
        },
        {
          src: require('@/assets/imgs/x2.png'),
          icon: require('@/assets/imgs/b1.png'),
          title: '农产品品质保险',
          content: ' 制定农产品品质评定标准，实现农产品品质评级有据可依，有险可保。并实现基于区块链的智能合约，实现保险的快速赔付。'
        },
        {
          src: require('@/assets/imgs/x3.png'),
          icon: require('@/assets/imgs/c1.png'),
          title: '优质农产品服务生态',
          content: ' 吸引更多的优质农企、检测机构、保险公司、电商平台入驻，打造优质农产品服务生态，运用区块链技术，使得生态内企业相互扶持，相互制约。'
        },
        {
          src: require('@/assets/imgs/x4.png'),
          icon: require('@/assets/imgs/d1.png'),
          title: '即时赔付',
          content: ' 建立“溯源即投保，消费可获陪”的消费意识，提升消费者溯源意识，并通过消费者相关信息，精准营销。'
        },
        {
          src: require('@/assets/imgs/x5.png'),
          icon: require('@/assets/imgs/e1.png'),
          title: '品牌建设',
          content: ' 完善企业质量管理体系，打造优质产品品牌，助力企业数量品牌形象。'
        },
      ],
      list2: [
        {
          src: require('@/assets/imgs/m-a.png'),
          icon: require('@/assets/imgs/a1@2x.png'),
          title: '数据可信',
          content: ' 利用区块链作为不可篡改、去中心化的“信任技术”，与大数据、物联网结合，解决信息孤岛，溯源信息的信任问题。'
        },
        {
          src: require('@/assets/imgs/b@2x.png'),
          icon: require('@/assets/imgs/b1@2x.png'),
          title: '农产品品质保险',
          content: ' 制定农产品品质评定标准，实现农产品品质评级有据可依，有险可保。并实现基于区块链的智能合约，实现保险的快速赔付。'
        },
        {
          src: require('@/assets/imgs/c@2x.png'),
          icon: require('@/assets/imgs/c1@2x.png'),
          title: '优质农产品服务生态',
          content: ' 吸引更多的优质农企、检测机构、保险公司、电商平台入驻，打造优质农产品服务生态，运用区块链技术，使得生态内企业相互扶持，相互制约。'
        },
        {
          src: require('@/assets/imgs/d@2x.png'),
          icon: require('@/assets/imgs/d1@2x.png'),
          title: '即时赔付',
          content: ' 建立“溯源即投保，消费可获陪”的消费意识，提升消费者溯源意识，并通过消费者相关信息，精准营销。'
        },
        {
          src: require('@/assets/imgs/e@2x.png'),
          icon: require('@/assets/imgs/e1@2x.png'),
          title: '品牌建设',
          content: ' 完善企业质量管理体系，打造优质产品品牌，助力企业数量品牌形象。'
        },
      ],
      activeName: "1",
      newsList:[],
      newsList3: [
        
        // {
        //   newsTitle: '品牌建设',
        //   newsDesc: ' 完善企业质量管理体系，打造优质产品品牌，助力企业数量品牌形象。',
        //   publishTime:"2020-01-01"
        // },
        {
          src: require('@/assets/imgs/x1.png'),
          icon: require('@/assets/imgs/a1.png'),
          newsTitle: '数据可信',
          newsDesc: ' 利用区块链作为不可篡改、去中心化的“信任技术”，与大数据、物联网结合，解决信息孤岛，溯源信息的信任问题。',
          publishTime:"2020-01-01"
        },
        {
          src: require('@/assets/imgs/x2.png'),
          icon: require('@/assets/imgs/b1.png'),
          newsTitle: '农产品品质保险',
          newsDesc: ' 制定农产品品质评定标准，实现农产品品质评级有据可依，有险可保。并实现基于区块链的智能合约，实现保险的快速赔付。',
          publishTime:"2020-01-01"
        },
        {
          src: require('@/assets/imgs/x3.png'),
          icon: require('@/assets/imgs/c1.png'),
          newsTitle: '优质农产品服务生态',
          newsDesc: ' 吸引更多的优质农企、检测机构、保险公司、电商平台入驻，打造优质农产品服务生态，运用区块链技术，使得生态内企业相互扶持，相互制约。',
          publishTime:"2020-01-01"
        },
        {
          src: require('@/assets/imgs/x4.png'),
          icon: require('@/assets/imgs/d1.png'),
          newsTitle: '即时赔付',
          newsDesc: ' 建立“溯源即投保，消费可获陪”的消费意识，提升消费者溯源意识，并通过消费者相关信息，精准营销。',
          publishTime:"2020-01-01"
        },
        {
          src: require('@/assets/imgs/x5.png'),
          icon: require('@/assets/imgs/e1.png'),
          newsTitle: '品牌建设',
          newsDesc: ' 完善企业质量管理体系，打造优质产品品牌，助力企业数量品牌形象。',
          publishTime:"2020-01-01"
        },{
          src: require('@/assets/imgs/x5.png'),
          icon: require('@/assets/imgs/e1.png'),
          newsTitle: '品牌建设',
          newsDesc: ' 完善企业质量管理体系，打造优质产品品牌，助力企业数量品牌形象。',
          publishTime:"2020-01-01"
        },
      ],
      wHeight: 0,
      ratio: 0,

    }
  },

  props: {},
  mounted() {
    this.getCodeList(1);
    this.wHeight = window.innerHeight;
    let ratio = parseFloat(this.wHeight / 1080).toFixed(2);
    this.ratio = ratio;
    // 初始化地图，设置中心点坐标和地图级别  
  },
  computed: {
    // ratio: function() {
    //   return parseFloat(this.wHeight / 1080).toFixed(2);
    // },
    ratioConfig: function () {
      return {
        ratio360: parseFloat(window.innerHeight / 1080).toFixed(2) * 360,
        ratio400: parseFloat(window.innerHeight / 1080).toFixed(2) * 460,
        ratio1000: parseFloat(window.innerHeight / 1080).toFixed(2) * 1000
      };
    }
  },
  methods: {
    // 移动端跳转
    toMnews(item){
      this.$router.push({ path: `/mnews`, query: { id: item.id, ac: item.ac } });
    },
    // 获取富文本中所有的图片地址
    getImgSrc(richtext) {
      let imgList = [];
      richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
            imgList.push(capture);
      });
    return imgList;
    },
    handleClick(tab, event) {
      //console.log(tab, event);
    },
    async getInfo(type) {
      let res = await this.$request.post(
        "/open/trace/product/wechat/queryNewsPage",
        {
          newsStatus: 1,
          newsType: type,
          limit: 4,
          page: 1
        },
      );
      if (res.code == 0) {
        this.newsList = res.data.data;
        console.log(res)
        console.log(this.newsList)
      }
    },
    /* 获取列表 */
    async getCodeList(page, isFromSearch) {
      if (isFromSearch) page = 1;
      let res = await this.$fetch(
        "/user/api/v1/newsList",
        {
          // newsStatus: this.searchStatus,
          // newsType: this.searchType,
          pageSize: this.pageLimit,
          pageNo: page
        },
        "POST"
      );
      if (res.code == 200) {

        console.log(res.data);
        this.newsList = res.data.list;
        // this.dataTotalLength = res.data.count;
      }
    },
    clickNew(id, ac) {
      this.$router.push({ path: `/news`, query: { id: id, ac: ac } });
    },

  },
  watch: {
    activeName(val) {
      // this.getInfo(val);
    }
  },
  components: {
    MyHeader,
    MobilenewHeader
    // HeadLine,
    // TabSearch
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.w100 {
  width: 100%;
}
@media screen and (max-width:768px) {
  .main {
    .header {
      display: none;
    }
    .m-header{
      // background: red;
    }
    .loopbox {
      display: none;
    }
    .m-loopbox{
      height: 38.3125rem;
      width: 100%;
      background: url('../../assets/imgs/m-banner1.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      p:nth-child(1){
        font-size: 2.375rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        padding-left: 10px;
        padding-right: 10px;
      }
      p:nth-child(2){
        font-size: 1.125rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 42px;
      }
      p:nth-child(3){
        font-size: 1.125rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 15px;
        line-height: 30px;
        padding-left: 10px;
        padding-right: 10px;
      }
      
    }
    .product{
      display: none;
    }
    .m-product{
      width: 100%;
      padding-top: 53px;
      // padding-bottom: 35px;
      // box-sizing: border-box;
      .w1200{
        width: 100%;
        // text-align: ;
        .title{
          .w100{
            width: 15.625rem
          }
        }
        .content{
          margin: 0px 20px;
          color: #333333;
          font-size: 18px;
          letter-spacing: 2px;
          line-height: 50px;
          // text-align: left;
        }
        .lct{
          margin-top: 35px;
          padding: 0 20px;
        }
      }
    }
    .youshi{
      display: none;
    }
    .m-youshi{
      // width: 750px;
      background: #FAFCFF;
      margin-top: 20px;
      padding-top: 0px;
      padding-bottom: 50px;
      padding-left: 20px;
      padding-right: 20px;
      
      .w750{
        margin: 0 auto;
        .title{
          .w100{
            margin-top: 40px;
            width: 250px;
            // height: 22px;
          }
        }
        .content{
          font-size: 1.125rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          padding: 0 10px;
          letter-spacing: 2px;
          line-height: 30px;
          margin-top: 40px;
          margin-bottom: 20px;
        }
        .list{
          .list-item{
            margin-top: 20px;
            .tips{
              height: 150px;
              width: 100%;
              // background: url('../../assets/imgs/m-a.png') no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              .icon{
                width:4.375rem;
                height: 4.375rem;
                margin-left: 40px;
              }
              .world{
                margin-left: 31px;
                font-size: 1.125rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
              }
            }
            .mc{
              padding: 10px 10px;
              background: #FFFFFF;
              border: 1px solid #F1F1F1;
              border-radius: 0px 0px 8px 8px;
              
              .discription{
                font-size: 1.125rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 40px;
              }
            }
          }
        }

      }
    }
    .news{
      display: none;
    }
    .m-news{
      background: #FFF;
      margin-top: 20px;
      padding: 0 20px;
      
      .w750{
        margin: 0 auto;
        .title{
          .w100{
            margin-top: 40px;
            width: 250px;
            // height: 22px;
          }
        }
        .content{
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          padding: 0 10px;
          letter-spacing: 2px;
          line-height: 30px;
          margin-top: 40px;
          margin-bottom: 20px;
        }
        .list{
          .list-item{
            margin-top: 20px;
            .tips{
              height: 150px;
              width: 100%;
              // background: url('../../assets/imgs/m-a.png') no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              border-radius: 3px 3px 0px 0px;
              .icon{
                margin-left: 40px;
              }
              .world{
                margin-left: 31px;
              }
            }
            .mc{
              padding: 10px 10px;
              background: #FFFFFF;
              border: 1px solid #F1F1F1;
              border-radius: 0px 0px 8px 8px;
              p{
                font-size: 1.125rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 24px;
                text-align: left;
                margin-left: 10px;
                
              
              }
              .discription{
                font-size: 1rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #7F7F7D;
                line-height: 22px;
                text-align: left;
                margin-left: 10px;
                margin-top: .625rem;
              }
            }
          }
        }

      }
      .m-load{
      margin-top: 30px;
      display: flex;
      justify-content: center;
      
        p{
          width: 210px;
          height: 50px;
          background: #FFFFFF;
          border: 1px solid #0083D5;
          border-radius: 8px;
          text-align: center;
          line-height: 50px;
          color: #0083D5;
          cursor: pointer;
        }
    }
    }
    .bottom{
      display: none;
    }
    .m-bottom{
      margin-top: 30px;
      background-color: #2A2F33;
      padding: 10px 0px;
      // div{
        p{
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #9EA5B5;
        }
        a{
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #9EA5B5;
        }
      // }
    }
  }
}
@media screen and (min-width:769px) {
.main {
  width: 100%;
  position: relative;
  .header {
    width: 100%;
    height: 72px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 66;
  }
   .m-header{
    display: none
  }
  .m-loopbox{
    display: none
  }
  .loopbox {
    width: 100%;
    height: 100vh;
    // min-height: 960px;
    position: relative;
    /deep/.el-carousel__container{
      width: 100%;
      height: 100%;
    }
    .search-box {
      width: 100%;
      height: 230px;
      background: rgba(0, 131, 213, 0.3);
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 999;
      .w1200 {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
      }
    }
    .loop-content {
      width: 100%;
      height: 100%;
      .loop-item {
        width: 100%;
        height: 100%;
        .lb-title1 {
          text-align: center;
          font-size: 70px;
          font-family: Source Han Sans CN;
          font-weight: 200;
          color: rgba(255, 255, 255, 1);
          width: 100%;
          position: absolute;
          left: 0;
          //   top: 360px;
          z-index: 996;
        }
        .lb-title2 {
          position: absolute;
          left: 0;
          bottom: 474px;
          z-index: 996;
          text-align: center;
          font-size: 24px;
          width: 100%;
          font-family: Source Han Sans CN;
          font-weight: 200;
          color: rgba(255, 255, 255, 1);
        }
        .w100 {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
  .m-product{
    display: none;
  }
  .product {
    width: 100%;
    padding-top: 92px;
    padding-bottom: 98px;
    box-sizing: border-box;
    .w1200 {
      width: 1200px;
      margin: 0 auto;
      .title {
        width: 418px;
        height: 48px;
        margin: 0 auto 40px;
      }
      .content {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 200;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        margin-bottom: 50px;
      }
      .lct {
        width: 753px;
        height: 384px;
        margin: 0 auto;
      }
    }
  }
  .m-youshi{
    display: none;
  }
  .youshi {
    width: 100%;
    height: 1080px;
    padding-top: 122px;
    margin-top: 105px;
    background-image: url('../../assets/imgs/ysbg.png');
    background-repeat: no-repeat;
    background-position: center center;
    .w1200 {
      width: 1200px;
      margin: 0 auto;
      .title {
        width: 270px;
        height: 46px;
        margin: 0 auto 36px;
      }
      .content {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 200;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        margin-bottom: 70px;
      }
      .list {
        width: 100%;
        height: 540px;
        border: 1px dashed #ccc;
        box-sizing: border-box;
        display: flex;
        .list-item {
          flex: 1;
          height: 100%;
          position: relative;
          border-right: 1px dashed #ccc;
          box-sizing: border-box;
          &:last-child {
            border-right: 0;
          }
          &:hover {
            .mc {
              display: block;
            }
          }
          .tips {
            width: 100%;
            position: absolute;
            top: 164px;
            text-align: center;
            padding: 0 50px;
            box-sizing: border-box;
            z-index: 66;
            .icon {
              width: 52px;
              height: 52px;
              margin-bottom: 30px;
            }
            .yi {
              margin: 0 auto 30px;
              width: 20px;
              height: 3px;
              background: #0083D5;
            }
            .world {
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
            }
          }
          .mc {
            width: 100%;
            height: 100%;
            
            background: rgba(0, 131, 213, 0.7);
            // background: rgba(137, 201, 221, 0.7);
            position: absolute;
            left: 0;
            top: 0;
            padding: 350px 25px 0;
            box-sizing: border-box;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 24px;
            display: none;
          }
        }
      }
    }
  }
  .m-news{
    display: none;
  }
  .news {
    width: 100%;
    min-height: 960px;
    padding-top: 97px;
    box-sizing: border-box;
    .w1200 {
      width: 1200px;
      margin: 0 auto;
      .title {
        width: 286px;
        height: 48px;
        background: url('../../assets/imgs/news1.svg') no-repeat;
        background-size: cover;
        margin: 0 auto 40px;
      }
    }
  }
  .news-center {
    width: 1200px;
    margin: 0 auto;
    .newsActive {
      width: 100%;
      position: relative;
      min-height: 500px;
    }
    .active-content {
      // width: 790px;
    }
    .active-content ul {
      // border-top: 1px solid rgba(242, 242, 242, 1);
      padding-bottom: 15px;
      margin-bottom: 20px;
    }
    .active-content ul li {
      cursor: pointer;
      margin-top: 15px;
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      height: 125px;
    }
    .active-content ul li p.new-name {
      width: 650px;
      height: 16px;
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(85, 85, 85, 1);
      margin-bottom: 17px;
      text-align: left;
    }
    .active-content ul li div.new-text {
      // width: 753px;
      height: 46px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 30px;
      margin-bottom: 20px;
      p {
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .active-content ul li div.new-text span {
      display: block;
      text-align: right;
      margin-top: 4px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(117, 117, 117, 1);
    }
    .active-right {
      float: left;
      position: absolute;
      top: -2px;
      right: 1px;
      width: 400px;
      a:first-child {
        position: absolute;
        right: 12px;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(57, 172, 95, 1);
      }
      ul.imgsList li {
        margin-top: 20px;
      }
      ul.imgsList li div.right-img {
        width: 400px;
        height: 236px;
      }
      ul.imgsList li div.right-img img {
        width: 400px;
        height: 236px;
      }
      ul.imgsList li div.right-img div {
        width: 100%;
        height: 58px;
        background: rgba(87, 183, 44, 0.1);
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        position: absolute;
        bottom: 0px;
      }
      ul.imgsList li div.right-img div p {
        margin-left: -267px;
        margin-top: 10px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .m-bottom{
    display: none;
  }
  .bottom{
    height: 88px;
    line-height: 88px;
    background-color: #181818;
    p{
      height: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
}

</style>
